import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';

import {
    Table,Col, Row, Card, CardBody,
    CardTitle, Button, Form, FormGroup, Label, Input ,Modal
} from 'reactstrap';

import VisualizzaRicevuta from '../SchedaIncassiAbbAss/VisualizzaRicevuta.js';

import Parametri from '../../parametri';
import TendinaEditabile from '../TendinaEditabile.js';
import TrasformaDateAUmano from '../TrasformaDateAUmano.js';

import AliquotaIVASelect from "../../AliquotaIVASelect.js";

import FormattaImportoVideo from '../FormattaImportoVideo.js';
import FormattaImportoDb from '../FormattaImportoDb.js';

import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';
import FinestraDialogo from '../FinestraDialogo.js';

import Cestino from "../../immagini/cestino.png";
import Interrogativo from '../../immagini/interrogativo-azzurro.png';

import { Page, Text, View, Document, StyleSheet,Image } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import styles from '../stiliPdf.js';
import controllaDataAAAAMMGG from '../controllaDataAAAAMMGG.js';

const STATO_INDEFINITO = 0;
const STATO_INSERISCI = 1;
const STATO_MEMORIZZAZIONE = 2;//utilizzato per eseguire le operazioni di inserimento/modifica/eliminazione record
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_OPERAZIONE_FALLITA = 4;
const STATO_RICERCA_DATI = 5;//utilizzato nel caso modifica e cancella quando vado a ricercare i dati per popolare i campi della scheda
const STATO_RICERCA_DATI_CORRETTA = 6;//utilizzato a valle della ricerca dati record in caso di modifica o cancellazione di un record
const STATO_SCARICA_PDF = 8;
const STATO_PREPARA_PDF = 9;
const STATO_VISUALIZZA_RICEVUTA = 10;
const STATO_VISUALIZZA_RICEVUTA_DOPO_INS = 11;

function SchedaIncassiDiversi(props) {

    const nextIdRef = useRef(1);
    var today = new Date();
    let sMese = String(today.getMonth()+1);
    if(sMese.length === 1) sMese = "0"+sMese;
    let sGiorno = String(today.getDate());
    if(sGiorno.length === 1) sGiorno = "0"+sGiorno;

    const dataOggi = today.getFullYear()+'-'+sMese+'-'+sGiorno
    
    const [operazione,setOperazione] = useState('');
    const [variazioneCampi,setVariazioneCampi]=useState(0);

    const [flagAttivaModaleIncassoNonCancellabile, setFlagAttivaModaleIncassoNonCancellabile] = useState(0);
    const [flagAttivaModaleInserisciEnte, setFlagAttivaModaleInserisciEnte] = useState(0);
    const [flagAttivaModaleInserisciIscritto, setFlagAttivaModaleInserisciIscritto] = useState(0);
    const [flagAttivaModaleRichiediPermessoInserire, setFlagAttivaModaleRichiediPermessoInserire] = useState(0);
    const [flagAttivaModaleRichiediPIVA, setFlagAttivaModaleRichiediPIVA] = useState(0);
    const [flagAttivaModaleInserisciDescrizione, setFlagAttivaModaleInserisciDescrizione] = useState(0);
    const [flagAttivaModaleInserisciDataPagamento, setFlagAttivaModaleInserisciDataPagamento] = useState(0);
    const [flagAttivaModaleInserisciDataEmissione, setFlagAttivaModaleInserisciDataEmissione] = useState(0);
    const [flagAttivaModaleInserisciRisorsa, setFlagAttivaModaleInserisciRisorsa] = useState(0);
    const [flagAttivaModaleInserisciVoceBilancio, setFlagAttivaModaleInserisciVoceBilancio] = useState(0);
    const [flagAttivaModaleInserisciImporto, setFlagAttivaModaleInserisciImporto]  = useState(0);
    const [flagAttivaModaleInserisciImportoPagamento, setFlagAttivaModaleInserisciImportoPagamento]  = useState(0);
    const [flagAttivaModaleImponibileErrato, setFlagAttivaModaleImponibileErrato] = useState(0);
    const [flagAttivaModaleImportoErrato, setFlagAttivaModaleImportoErrato] = useState(0);
    const [flagAttivaModaleIvaErrata, setFlagAttivaModaleIvaErrata] = useState(0);
    const [flagAttivaModaleImportoPagamentoErrato, setFlagAttivaModaleImportoPagamentoErrato] = useState(0);
    const [flagAttivaModaleIvaPagamentoErrata, setFlagAttivaModaleIvaPagamentoErrata] = useState(0);
    const [flagAttivaModaleSpiegaAttivita, setFlagAttivaModaleSpiegaAttivita] = useState(0);

    const [flagModaleInfoStato, setFlagModaleInfoStato] = React.useState(false);
    const [flagModaleInfoImporto, setFlagModaleInfoImporto] = React.useState(false);

    const dataEmissione   = useRef();
    //const stato   = useRef();
    const note   = useRef();

    const dataScadenzaRata   = useRef({});
    const dataPagamentoRata   = useRef({});
    const importoRata   = useRef({});
    //const ivaRata   = useRef({});
    const noteRata   = useRef({});

    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [statoTendinaIscritti,setStatoTendinaIscritti]=useState(false);
    const [statoTendinaClienteFornitore,setStatoTendinaClienteFornitore]=useState(false);
    const [statoRicercaRateFattura,setStatoRicercaRateFattura]=useState(false);
    const [statoTendinaRisorse,setStatoTendinaRisorse]=useState(false);
    const [statoTendinaVociDiBilancio,setStatoTendinaVociDiBilancio]=useState(false);
    const [statoRicercaAliquotaIVA,setStatoRicercaAliquotaIVA]=useState(false);

    const [error,setError]=useState('');
    //const [risultatoServer,setRisultatoServer]=useState('');

    const [risultatoServerDatiClienteFornitore,setRisultatoServerDatiClienteFornitore]=useState('');
    const [risultatoServerDatiIscritti,setRisultatoServerDatiIscritti]=useState('');
    const [risultatoServerDatiTutteRisorse,setRisultatoServerDatiTutteRisorse]=useState('');
    const [risultatoServerDatiTutteVociDiBilancio,setRisultatoServerDatiTutteVociDiBilancio]=useState('');

    // arrayRataFatt contiene tutti i dati di ogni pagamento (rata), scaricati dal backend
    // gli altri array...RataFatt contengono gli stessi dati che sono in arrayRataFatt, duplicati,
    // per ragioni storiche di questo componente, prima c'erano solo questi.
    // Quindi ad esempio arrayRataFatt[i].IMPORTO è uguale a arrayImportoRataFatt[i].
    // Ma negli array separati non ci sono tutti i dati che ha arrayRataFatt, i campi nuovi sono solo in arrayRataFatt e se si
    // aggiungono campi vanno messi solo qui: basta aggiungerli in aggiungiPagamento() e fetchOperazioneServer() e naturalmente nel backend.
    // Attenzione quindi a quali sono gli array aggiornati quando l'utente inserisce dati, questi vanno inviati al backend per ins e mod
    // A TENDERE si dovrebbe usare solo arrayRataFatt, se ci sarà il tempo di farlo
    const [arrayRataFatt, setArrayRataFatt] = useState([]);
    const [arrayRisorsaRataFatt,setArrayRisorsaRataFatt]=useState([]);
    const [arrayVociDiBilancioRataFatt,setArrayVociDiBilancioRataFatt]=useState([]);
    const [arrayVociDiBilancioAttRataFatt,setArrayVociDiBilancioAttRataFatt]=useState([]);
    const [arrayImportoRataFatt,setArrayImportoRataFatt]=useState([]);
    const [arrayIvaRataFatt,setArrayIvaRataFatt]=useState([]);
    const [arrayDataScadenzaRataFatt,setArrayDataScadenzaRataFatt]=useState([]);
    const [arrayDataPagamentoRataFatt,setArrayDataPagamentoRataFatt]=useState([]);
    const [arrayNoteRataFatt,setArrayNoteRataFatt]=useState([]);
    const [arrayNumeroRate,setArrayNumeroRate]=useState([]);

    const [importoTotaleLordo,setImportoTotaleLordo]=useState('');
    const [imponibileTotale,setImponibileTotale]=useState('');
    const [ivaTotale,setIvaTotale]=useState('');
    const [importoNonPagato,setImportoNonPagato]=useState('');
    const [descrizioneDefault,setDescrizioneDefault]=useState('');
    const [dataEmissioneDefault,setDataEmissioneDefault]=useState(dataOggi);
    const [noteDefault,setNoteDefault]=useState('');
    
    const [dettaglioLinee, setDettaglioLinee] = useState([]); // sono gli articoli in fattura, chiamate dettaglio linee in fattura elettronica
 
    const [insIscrittiEdi,setInsIscrittiEdi]=useState('');
    const [codiceFiscaleIscritto,setCodiceFiscaleIscritto]=useState('');
    
    const [insClienteFornitoreEdi,setInsClienteFornitoreEdi]=useState('');
    const [codiceFiscaleClienteFornitore,setCodiceFiscaleClienteFornitore]=useState('');

    const [insStato,setInsStato]=useState("Non pagato");

    const [permessoInserireEnte,setPermessoInserireEnte]=useState(0);
    const [permessoInserireRisorsa,setPermessoInserireRisorsa]=useState(0);
    const [permessoInserireVoceDiBilancio,setPermessoInserireVoceDiBilancio]=useState(0);
    const [permessoCancellazioneForzata,setPermessoCancellazioneForzata]=useState(0);

    const [risorseNuove,setRisorseNuove]=useState([]);
    const [vociDiBilancioNuove,setVociDiBilancioNuove]=useState([]);
    const [aliquotaIVAIniziale,setAliquotaIVAIniziale]=useState(0);

    //const [rivisualizza,setRivisualizza]=useState(0);

    //const [aggiornatoImportoRata,setAggiornatoImportoRata]=useState(0);
    //const [aggiornatoIvaRata,setAggiornatoIvaRata]=useState(0);

    const [disabilitaBottoni,setDisabilitaBottoni]= useState(false);
    const [loading,setLoading]= useState(false);

    const [ricercaLogo,setRicercaLogo]=useState('');
    const [fileLogo,setFileLogo]=useState('');
    const [typeLogo,setTypeLogo]=useState('');
    const [nomeSocieta,setNomeSocieta]=useState('');
    const [capSocieta,setCapSocieta]=useState('');
    const [cittaSocieta,setCittaSocieta]=useState('');
    const [indirizzoSocieta,setIndirizzoSocieta]=useState('');
    const [pIvaSocieta,setPIvaSocieta]=useState('');
    const [codiceFiscaleSocieta,setCodiceFiscaleSocieta]=useState('');

    const [ricevutaNumero, setRicevutaNumero] = useState(-1); // da eliminare, per le vecchie ricevute 
    const [rataSelezionata, setRataSelezionata] = useState(-1); // per le nuove ricevute

    const [ricevuta,setRicevuta]=useState(0);

    var elem = document.getElementById("cont");
    const [larghezzaPdf,setLarghezzaPdf] = useState(0);

    const [enteEsternoPdf,setEnteEsternoPdf]=useState('');

    const [operazioneInterna,setOperazioneInterna]=useState('');

    // contiene l'ultima ricevuta fatta in caso di inserimento, è una stringa che rappresenta il json,
    // mentre le singole ricevute dei pagamenti precedenti sono in arrayRataFatt[rataSelezionata].JSON_RICEVUTA
    const [stringaJsonRicevuta, setStringaJsonRicevuta] = useState({}); 

    useEffect(() => {
      if(elem) setLarghezzaPdf(elem.getBoundingClientRect().width); 
    },[elem]);
    
    useEffect(() => {
        if(statoPagina === STATO_PREPARA_PDF){
            setStatoPagina(STATO_SCARICA_PDF);
        }
    },[statoPagina]);

    useEffect(() => {
        setStatoPagina(STATO_INSERISCI);
        setStatoTendinaIscritti(false);
        setStatoTendinaClienteFornitore(false);
        setPermessoInserireEnte(0);
        setPermessoInserireRisorsa(0);
        setPermessoInserireVoceDiBilancio(0);
        setPermessoCancellazioneForzata(0);
        setInsStato("Non pagato");
        scaricaLogo();
        //setAggiornatoImportoRata(0);
        //setAggiornatoIvaRata(0);
    },[]);

    useEffect(() => {
        //se la partita iva non è stata dichiarata nel pdf non metto (-) alla fine della ragione sociale, altrimenti ho ragione sociale + partita iva
            if(insClienteFornitoreEdi != ''){
                if(insClienteFornitoreEdi.endsWith('(-)')){
                    //se non c'è la partita iva tolgo (-) e se ho codice fiscale, metto quello tra parentesi in fattura:
                    if (codiceFiscaleClienteFornitore != ''){
                        let compongo = '';
                        compongo = insClienteFornitoreEdi.slice(0, -3) + "(" + codiceFiscaleClienteFornitore+ ")";
                        setEnteEsternoPdf(compongo)//tolgo (-) e metto il codice fiscale
                    }else{
                        setEnteEsternoPdf(insClienteFornitoreEdi.slice(0, -3))//tolgo (-) e non metto altro
                    }
                }else{
                    //se non c'è la partita iva lascio com'è:
                    setEnteEsternoPdf(insClienteFornitoreEdi)
                }
            }
       
    },[insClienteFornitoreEdi]);

    useEffect(() => {
        if(
            ((statoTendinaIscritti && props.tipologia==="incassi_iscritti") || (statoTendinaClienteFornitore && props.tipologia==="incassi_fornitori")) && 
            statoRicercaRateFattura === true &&  
            statoTendinaRisorse === true && 
            statoTendinaVociDiBilancio === true && 
            statoRicercaAliquotaIVA === true && 
            ricercaLogo === 1){
            setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
            if(props.ope === "inserisci") {
                aggiungiLinea();
                aggiungiPagamento();
                console.log("AGGIUNGO");
            }
        }
    },[statoTendinaIscritti, statoTendinaClienteFornitore,statoRicercaRateFattura,statoTendinaRisorse,statoTendinaVociDiBilancio,statoRicercaAliquotaIVA,ricercaLogo]);

    useEffect(() => {
        //if(props.ope === "inserisci" || (props.ope === "modifica" && variazioneCampi === 1)) aggiornaStatoPagamentoFattura();
        aggiornaStatoPagamentoFattura();
    },[arrayImportoRataFatt,arrayNumeroRate,importoTotaleLordo]);

    useEffect(() => {
        if((props.ope==="modifica" || props.ope==="inserisci") && 
        (permessoInserireEnte===1 && permessoInserireRisorsa===1 && permessoInserireVoceDiBilancio===1)){
            if(ricevuta===1) fetchOperazioneServer(0,1);
            else fetchOperazioneServer();
        } 
        if(props.ope==="cancella" && permessoCancellazioneForzata === 1) fetchOperazioneServer();
    },[permessoInserireEnte,permessoInserireRisorsa,permessoInserireVoceDiBilancio,permessoCancellazioneForzata]);

    useEffect(() => {
        if(props.ope==='inserisci' || operazioneInterna === 'copia') setOperazione("fattureIns");
        if(props.ope==='modifica' && operazioneInterna === '') setOperazione("fattureMod");
        if(props.ope==='cancella') setOperazione("fattureCanc");

        if(operazioneInterna === 'copia'){
            setDisabilitaBottoni(false);
            setDataEmissioneDefault('');
            setArrayDataPagamentoRataFatt([]);
            setArrayDataScadenzaRataFatt([]);
            setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
        }else{
            if(props.ope==="modifica" || props.ope==="cancella"){
                //devo eseguire una fetch per popolare i campi della scheda con i dati presi da db per il record in esame:
                // parametri per inviare i dati al server:
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({op:"fattureRecuperaDati",
                        tipologia:props.tipologia,
                        id:props.id,
                        emak: props.emak,
                        sessionId:props.sessionId
                    })
                };
                setStatoPagina(STATO_RICERCA_DATI);

                fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                .then(risposta => risposta.json())
                .then(
                    (valoreDiRitorno) => {
                        if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                            alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                        }
                        if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                        if(valoreDiRitorno.risultatoOperazione===1){
                        //setRisultatoServer(valoreDiRitorno.risultatoRitorno);
                    
                        if (props.tipologia=="incassi_fornitori") {
                            let componiFornitore="";
                            if(valoreDiRitorno.risultatoRitorno[0].COGNOME !== '' && valoreDiRitorno.risultatoRitorno[0].COGNOME !== undefined) componiFornitore = componiFornitore + valoreDiRitorno.risultatoRitorno[0].COGNOME;
                            if(valoreDiRitorno.risultatoRitorno[0].P_IVA !== '' && valoreDiRitorno.risultatoRitorno[0].P_IVA !== undefined && componiFornitore !== "" ) componiFornitore = componiFornitore + " ";
                            if(valoreDiRitorno.risultatoRitorno[0].P_IVA !== '' && valoreDiRitorno.risultatoRitorno[0].P_IVA !== undefined ) componiFornitore = componiFornitore + "("+valoreDiRitorno.risultatoRitorno[0].P_IVA+")";
                            //setInsClienteFornitoreEdi(valoreDiRitorno.risultatoRitorno[0].COGNOME);
                            setInsClienteFornitoreEdi(componiFornitore);//serve per settare la var di stato se non cambi valore nella tendina in caso di modifica
                            setCodiceFiscaleClienteFornitore(valoreDiRitorno.risultatoRitorno[0].CODICE_FISCALE);
                        }

                        if (props.tipologia=="incassi_iscritti") {
                            let componiPersona="";
                            if(valoreDiRitorno.risultatoRitorno[0].COGNOME_ISCRITTO !== '' && valoreDiRitorno.risultatoRitorno[0].COGNOME_ISCRITTO !== undefined) componiPersona = componiPersona + valoreDiRitorno.risultatoRitorno[0].COGNOME_ISCRITTO;
                            if((valoreDiRitorno.risultatoRitorno[0].NOME_ISCRITTO !== '' && valoreDiRitorno.risultatoRitorno[0].NOME_ISCRITTO !== undefined) && componiPersona !== "") componiPersona = componiPersona + " ";
                            if(valoreDiRitorno.risultatoRitorno[0].NOME_ISCRITTO !== '' && valoreDiRitorno.risultatoRitorno[0].NOME_ISCRITTO !==undefined) componiPersona = componiPersona + valoreDiRitorno.risultatoRitorno[0].NOME_ISCRITTO;
                            if((valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA !== '' && valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA !== undefined) && componiPersona !== "") componiPersona = componiPersona + " ";
                            if(valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA !== '' && valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA !== undefined) componiPersona = componiPersona + "("+valoreDiRitorno.risultatoRitorno[0].NUMERO_TESSERA+")";
                            setInsIscrittiEdi(componiPersona);//serve per settare la var di stato se non cambi valore nella tendina in caso di modifica
                            setCodiceFiscaleIscritto(valoreDiRitorno.risultatoRitorno[0].CODICE_FISCALE_ISCRITTO);
                        }

                        //setDefaultEnte(valoreDiRitorno.risultatoRitorno[0].COGNOME);

                        // non setto i valori totali (Imponibile, IVA e Importo Lordo) perchè ci pensa lo useEffect su dettaglioLinee
                        // a fare la somma degli importi e calcolare poi imponibile e iva
                        /*
                        setImportoTotaleLordo(valoreDiRitorno.risultatoRitorno[0].IMPORTO);
                        setImponibileTotale(valoreDiRitorno.risultatoRitorno[0].IMPONIBILE);
                        setIvaTotale(valoreDiRitorno.risultatoRitorno[0].IVA);
                        */

                        setDescrizioneDefault(valoreDiRitorno.risultatoRitorno[0].DESCRIZIONE);
                        setInsStato(valoreDiRitorno.risultatoRitorno[0].STATO);
                        setDataEmissioneDefault(valoreDiRitorno.risultatoRitorno[0].DATA_EMISSIONE);
                        setNoteDefault(valoreDiRitorno.risultatoRitorno[0].NOTE);

                        const raw = valoreDiRitorno?.risultatoRitorno?.[0]?.DETTAGLIO_LINEE;

                        // se manca o è vuoto -> una riga vuota iniziale
                        if (raw == null || raw === "" || (Array.isArray(raw) && raw.length === 0)) {
                            setDettaglioLinee([
                            {
                                _id: nextIdRef.current++,
                                descrizione: "",
                                importoIVAC: "0.00",                              // nello stato con il punto
                                aliquotaIVA: String(aliquotaIVAIniziale ?? "22"), // sempre stringa
                            },
                            ]);                            
                        } else {

                            // prova a ottenere un array dai dati (accetta stringa JSON o array già pronto)
                            let arr;
                            try {
                                arr = Array.isArray(raw) ? raw : JSON.parse(raw);
                            } catch {
                                arr = [];
                            }

                            if (!Array.isArray(arr) || arr.length === 0) {   
                                setDettaglioLinee([
                                {
                                    _id: nextIdRef.current++,
                                    descrizione: "",
                                    importoIVAC: "0.00",
                                    aliquotaIVA: String(aliquotaIVAIniziale ?? "22"),
                                },
                                ]);                            
                            } else {
                                // normalizza: descrizione trim, importo con punto e 2 decimali, aliquota sempre stringa
                                const normalized = arr.map((r) => {
                                    const descrizione = String(r?.descrizione ?? "").trim();

                                    const importoNum = Number(String(r?.importoIVAC ?? r?.importo ?? "0").replace(",", "."));
                                    const importoIVAC = Number.isFinite(importoNum) ? importoNum.toFixed(2) : "0.00"; // "12.34"

                                    const aliquotaIVA = String(r?.aliquotaIVA ?? r?.aliquota ?? r?.iva ?? (aliquotaIVAIniziale ?? "22"));

                                    return {
                                    _id: nextIdRef.current++,
                                    descrizione,
                                    importoIVAC,
                                    aliquotaIVA, // sempre stringa (es. "22" o "N4")
                                    };
                                });

                                setDettaglioLinee(normalized);
                            }
                        }

                        if (props.tipologia==="incassi_fornitori") ricercaDatiClienteFornitore();
                        if (props.tipologia==="incassi_iscritti") ricercaDatiIscritti(); 
                        ricercaDatiRateFattura();
                        ricercaDatiTutteRisorse();
                        ricercaDatiTutteVociDiBilancio();
                        ricercaDatiAliquotaIVA();
                        }
                        },
                    (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
                ); 
            }else{
                setStatoPagina(STATO_RICERCA_DATI);
                if (props.tipologia==="incassi_fornitori") ricercaDatiClienteFornitore();
                if (props.tipologia==="incassi_iscritti") ricercaDatiIscritti();
                ricercaDatiRateFattura(props.ope);
                ricercaDatiTutteRisorse();
                ricercaDatiTutteVociDiBilancio();
                ricercaDatiAliquotaIVA();
            }
        }
    },[props.ope,operazioneInterna]);

    useEffect(() => {
        let totImportoCents = 0;
        let totIvaCents = 0;
        let totImponibileCents = 0;
        if (dettaglioLinee.length==0) return;

        (dettaglioLinee || []).forEach((r) => {
            // importo interno con punto (string) -> numero
            const importoNum = Number(String(r?.importoIVAC ?? "0").replace(",", "."));
            if (!isFinite(importoNum)) return;

            const importoCents = Math.round(importoNum * 100);
            totImportoCents += importoCents;

            // aliquota: numero > 0 => aliquota, altrimenti 0 (nature N*)
            const aliq = (() => {
                const raw = r?.aliquotaIVA;
                if (raw == null) return 0;
                const n = parseFloat(String(raw).trim());
                return Number.isFinite(n) && n > 0 ? n : 0;
            })();

            const imponibileCents = 
            aliq > 0 ? Math.round(importoCents / ((100+aliq)/100)) : importoCents;

            // IVA per riga, arrotondata ai centesimi: IVA = importo * aliq / (100 + aliq)
            // (importo è IVA compresa)
            const ivaCents =
            aliq > 0 ? Math.round(imponibileCents * aliq / 100) : 0;

            totIvaCents += ivaCents;
            totImponibileCents += imponibileCents;
        });

        const importoTotaleLordo = (totImportoCents / 100).toFixed(2);
        const ivaTotale = (totIvaCents / 100).toFixed(2);
        const imponibileTotale = (totImponibileCents / 100).toFixed(2);

        setImportoTotaleLordo(importoTotaleLordo);
        setIvaTotale(ivaTotale);
        setImponibileTotale(imponibileTotale);
        calcolaPrimoPagamento(importoTotaleLordo);
    }, [dettaglioLinee]);

    function callbackVisualizzaRicevuta() {
        setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
    }

    function copiaMovimento(){
        if (window.confirm("Sei sicuro di voler procedere con la copia dell' incasso selezionato?")) {
            setDisabilitaBottoni(true);
            setStatoPagina(STATO_RICERCA_DATI);
            setOperazioneInterna("copia");
        }
    }

    function scaricaLogo() {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"ricercaLogo", emak: props.emak,sessionId: props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {          
              if(valoreDiRitorno.risultatoOperazione===1){
                  if (valoreDiRitorno.risultatoRitorno[0].FILE !== undefined) {
                    setFileLogo(valoreDiRitorno.risultatoRitorno[0].FILE);
                    setTypeLogo(valoreDiRitorno.risultatoRitorno[0].TYPE);
                    setNomeSocieta(valoreDiRitorno.risultatoRitorno[0].NOME);
                    setCapSocieta(valoreDiRitorno.risultatoRitorno[0].CAP);
                    setCittaSocieta(valoreDiRitorno.risultatoRitorno[0].CITTA);
                    setIndirizzoSocieta(valoreDiRitorno.risultatoRitorno[0].INDIRIZZO);
                    setPIvaSocieta(valoreDiRitorno.risultatoRitorno[0].PIVA);
                    setCodiceFiscaleSocieta(valoreDiRitorno.risultatoRitorno[0].CODICE_FISCALE);
                  }
                  setRicercaLogo(1);
              }
          },
          (error) => {console.log("Errore connessione");}
        );        
      }

    function calcolaPrimoPagamento(val){
        let importo = [...arrayImportoRataFatt];

        if(props.ope=='inserisci' && arrayNumeroRate.length==1){
            importo.splice(0,1,val);//modifico l'elemento desiderato
            setArrayImportoRataFatt(importo);
        }
        ricalcolaIvaRate(val,ivaTotale,importo);        
    }

    function ricercaDatiAliquotaIVA() {
        //ricerco i clienti ed i fornitori che mi servono per popolare le tendine:
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"impostazioniSocietaRecuperaDati",emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                setLoading(false);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){

                // le aliquote in tabella SOCIETA arrivano sempre come stringhe
                // ma possono contenere il valore dell'aliquota (es. 4,5,10,22) oppure un codice alfanumerico (es. N.1) se l'aliquota è zero.
                // Per capire se applicare zero oppure il valore contenuto, il programma verifica se l'aliquota IVA è un Number o no,
                // quindi adesso dobbiamo memorizzare nella variabile di stato un Numero se l'aliquota è numerica, anche se arriva come stringa,
                // altrimenti ovviamente resta stringa se contiene caratteri alfanumerici.
                // Per convertire la stringa v in numero, uso Number(v)
                const v = valoreDiRitorno.risultatoRitorno[0].ALIQUOTA_IVA_ESTERNI;
                const isNumeric = /^[+-]?\d+(\.\d+)?$/.test(v);
                setAliquotaIVAIniziale(isNumeric ? Number(v) : v);

                setStatoRicercaAliquotaIVA(true);
                }
            },
            (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function ricercaDatiClienteFornitore() {
        //ricerco i clienti ed i fornitori che mi servono per popolare le tendine:
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoCliFor",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                setLoading(false);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                setRisultatoServerDatiClienteFornitore(valoreDiRitorno.risultatoRitorno);
                setStatoTendinaClienteFornitore(true);
                }
            },
            (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function ricercaDatiIscritti() {
        //ricerco gli iscritti che mi servono per popolare le tendine:
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoPersone",ridotto:1,recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                setLoading(false);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                setRisultatoServerDatiIscritti(valoreDiRitorno.risultatoRitorno);
                setStatoTendinaIscritti(true);
                }
            },
            (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function ricercaDatiRateFattura(operazione) {
        if(operazione==='inserisci'){
            setStatoRicercaRateFattura(true);
        }else{
            
            //ricerco tutte le rate della fattura in esame:
            setLoading(true);
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({op:"elencoRateFattura",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId,idFattura:props.id,})
            };
    
            fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                .then(risposta => risposta.json())
                .then(
                (valoreDiRitorno) => {
                    setLoading(false);
                    if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                        alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                    }
                    if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                    if(valoreDiRitorno.risultatoOperazione===1){

                        setArrayRataFatt(valoreDiRitorno.risultatoRitorno);
             
                        let arrLocaleRisorsaRataFatt=[];
                        let arrLocaleVociDiBilancioRataFatt=[];
                        let arrLocaleVociDiBilancioAttRataFatt=[];
                        let arrLocaleImportoRataFatt=[];
                        let arrLocaleIvaRataFatt=[];
                        let arrLocaleDataScadenzaRataFatt=[];
                        let arrLocaleDataPagamentoRataFatt=[];
                        let arrLocaleNoteRataFatt=[];
                        let arrLocaleNumeroRate=[];
        
                        for (let i=0; i<valoreDiRitorno.risultatoRitorno.length ; i++) {
                                                                                                
                            arrLocaleRisorsaRataFatt[i]=valoreDiRitorno.risultatoRitorno[i].RISORSA;  
                            //let risorseAppoggio = [...defaultRisorse];
                            //risorseAppoggio.push(valoreDiRitorno.risultatoRitorno[i].RISORSA);
                            //setDefaultRisorse(risorseAppoggio); 
                            arrLocaleVociDiBilancioRataFatt[i]=valoreDiRitorno.risultatoRitorno[i].VOCE_DI_BILANCIO;     
                            arrLocaleVociDiBilancioAttRataFatt[i]=valoreDiRitorno.risultatoRitorno[i].TIPO_ATTIVITA;    
                            //let vociAppoggio = [...defaultVociDiBilancio];
                            //vociAppoggio.push(valoreDiRitorno.risultatoRitorno[i].VOCE_DI_BILANCIO);
                            //setDefaultVociDiBilancio(vociAppoggio);              
                            arrLocaleImportoRataFatt[i]=valoreDiRitorno.risultatoRitorno[i].IMPORTO_RATA;
                            arrLocaleIvaRataFatt[i]=valoreDiRitorno.risultatoRitorno[i].IVA_RATA;
                            arrLocaleDataScadenzaRataFatt[i]=valoreDiRitorno.risultatoRitorno[i].DATA_SCADENZA_RATA;                    
                            arrLocaleDataPagamentoRataFatt[i]=valoreDiRitorno.risultatoRitorno[i].DATA_PAGAMENTO_RATA;                      
                            arrLocaleNoteRataFatt[i]=valoreDiRitorno.risultatoRitorno[i].NOTE_RATA;    
                            //aggiorno il numero di rate:
                            arrLocaleNumeroRate.push(i);
                            
                        } 
                        //setDefaultRisorse(arrLocaleRisorsaRataFatt);
                        //setDefaultVociDiBilancio(arrLocaleVociDiBilancioRataFatt);

                        setArrayRisorsaRataFatt(arrLocaleRisorsaRataFatt);
                        setArrayVociDiBilancioRataFatt(arrLocaleVociDiBilancioRataFatt);
                        setArrayVociDiBilancioAttRataFatt(arrLocaleVociDiBilancioAttRataFatt);
                        setArrayImportoRataFatt(arrLocaleImportoRataFatt);
                        setArrayIvaRataFatt(arrLocaleIvaRataFatt);
                        setArrayDataScadenzaRataFatt(arrLocaleDataScadenzaRataFatt);
                        setArrayDataPagamentoRataFatt(arrLocaleDataPagamentoRataFatt);
                        setArrayNoteRataFatt(arrLocaleNoteRataFatt);
                        setArrayNumeroRate(arrLocaleNumeroRate);
                        setStatoRicercaRateFattura(true);
                    }
                },
                (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
                );
        }
    }

    function ricercaDatiTutteRisorse() {
        //ricerco tutte le risorse disponibili che mi servono per popolare la tendina:
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoRisorse",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                setLoading(false);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                setRisultatoServerDatiTutteRisorse(valoreDiRitorno.risultatoRitorno);         
                setStatoTendinaRisorse(true);
                }
            },
            (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function ricercaDatiTutteVociDiBilancio() {
        //ricerco tutte le risorse disponibili che mi servono per popolare la tendina:
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoVociDiBilancio",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                setLoading(false);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                setRisultatoServerDatiTutteVociDiBilancio(valoreDiRitorno.risultatoRitorno);         
                setStatoTendinaVociDiBilancio(true);
                }
            },
            (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function callbackSetValoreTendEditabileCliFor(valore,posizione,valoreNonVisibile){
        setInsClienteFornitoreEdi(valore);
        setCodiceFiscaleClienteFornitore(valoreNonVisibile);
        //setDefaultEnte(valore);
    }


    function callbackSetValoreTendEditabileRisorsa(valore,index){
        let dati = [...arrayRisorsaRataFatt];//popolo l'array locale con i dati dell'array di stato
        dati.splice(index,1,valore);//);
        setArrayRisorsaRataFatt(dati);//aggiorno nuovamente la var di stato
        
    }

    function callbackSetValoreTendEditabileVociDiBilancio(valore,index,valoreNonVisibile){
        let dati = [...arrayVociDiBilancioRataFatt];//popolo l'array locale con i dati dell'array di stato
        dati.splice(index,1,valore);//);
        setArrayVociDiBilancioRataFatt(dati);//aggiorno nuovamente la var di stato

        let dati1 = [...arrayVociDiBilancioAttRataFatt];//popolo l'array locale con i dati dell'array di stato
        dati1.splice(index,1,valoreNonVisibile);//);
        setArrayVociDiBilancioAttRataFatt(dati1);//aggiorno nuovamente la var di stato
    }

    function aggiornaProssimaVoceDiBilancio(index){
        //quando aggiungo un pagamento: controllo la prima voce di bilancio e la pongo uguale: in questo modo suggesco l'omogeneità 
        //delle voci dando comunque la possibilità di variarle
        
        let dati = [...arrayVociDiBilancioRataFatt];//popolo l'array locale con i dati dell'array di stato
        if(!dati[index+1] || (dati[index+1] && dati[index+1]==='')){
            dati.splice(index+1,1,arrayVociDiBilancioRataFatt[0]);
            setArrayVociDiBilancioRataFatt(dati);//aggiorno nuovamente la var di stato
        }
    }
    function aggiornaProssimaDataPagamento(index,dataOggi){
        //la data di pagamento successiva la pondo di default = alla data di oggi:
        let dati = [...arrayDataPagamentoRataFatt];//popolo l'array locale con i dati dell'array di stato
        if(!dati[index+1] || (dati[index+1] && dati[index+1]==='')){
            dati.splice(index+1,1,dataOggi);
            setArrayDataPagamentoRataFatt(dati);//aggiorno nuovamente la var di stato
        }
    }

    function tornaElenco() {
        props.callbackTermineModifica();
    }
    function tornaScheda() {


        setFlagAttivaModaleIncassoNonCancellabile(0);
        setFlagAttivaModaleInserisciEnte(0);
        setFlagAttivaModaleInserisciIscritto(0);
        setFlagAttivaModaleRichiediPermessoInserire(0);
        setFlagAttivaModaleRichiediPIVA(0);
        setFlagAttivaModaleInserisciDescrizione(0);
        setFlagAttivaModaleInserisciDataPagamento(0);
        setFlagAttivaModaleInserisciDataEmissione(0);
        setFlagAttivaModaleInserisciRisorsa(0);
        setFlagAttivaModaleInserisciVoceBilancio(0);
        setFlagAttivaModaleInserisciImporto(0);
        setFlagAttivaModaleInserisciImportoPagamento(0);
        setFlagAttivaModaleImponibileErrato(0);
        setFlagAttivaModaleImportoErrato(0);
        setFlagAttivaModaleIvaErrata(0);
        setFlagAttivaModaleImportoPagamentoErrato(0);
        setFlagAttivaModaleIvaPagamentoErrata(0);
        setRicevuta(0);

        setFlagModaleInfoStato(false);
        setFlagModaleInfoImporto(false);


    }

    function handleCambiamentoMod(event) {
        //event.preventDefault();
        setVariazioneCampi(1);
    }

   
    function eliminaRataFattura(posizione) {
        let nrat = [...arrayNumeroRate];//popolo l'array locale con i dati dell'array di stato
        nrat.splice(posizione, 1);//cancello l'elemento desiderato
        setArrayNumeroRate(nrat);//aggiorno nuovamente la var di stato

        let riso = [...arrayRisorsaRataFatt];//
        riso.splice(posizione, 1);//
        setArrayRisorsaRataFatt(riso);//
        //setDefaultRisorse(riso);

        let voci = [...arrayVociDiBilancioRataFatt];//
        voci.splice(posizione, 1);//
        setArrayVociDiBilancioRataFatt(voci);//
        //setDefaultVociDiBilancio(voci);

        let dscad = [...arrayDataScadenzaRataFatt];//
        dscad.splice(posizione, 1);//
        setArrayDataScadenzaRataFatt(dscad);//

        let dpag = [...arrayDataPagamentoRataFatt];//
        dpag.splice(posizione, 1);//
        setArrayDataPagamentoRataFatt(dpag);//

        let importo = [...arrayImportoRataFatt];//
        importo.splice(posizione, 1);//
        setArrayImportoRataFatt(importo);//

        let iva = [...arrayIvaRataFatt];//
        iva.splice(posizione, 1);//
        setArrayIvaRataFatt(iva);//

        let note = [...arrayNoteRataFatt];//
        note.splice(posizione, 1);//
        setArrayNoteRataFatt(note);//

        let rataFatt = [...arrayRataFatt];//
        rataFatt.splice(posizione, 1);//
        setArrayRataFatt(rataFatt);//

        //setRivisualizza(rivisualizza+1);
    }

    function aggiornaStatoPagamentoFattura(){       
        // aggiorna lo stato del pagamento
        
        let datiStato = [...arrayImportoRataFatt];
        let i = 0;
        let sommatoriaRate = 0;
        for (i=0; i<datiStato.length; i++) { 
            if(datiStato[i]!==undefined && datiStato[i]!==''){
                sommatoriaRate = sommatoriaRate + parseFloat(datiStato[i]);
            }
        }

        //confronto il totale delle rate con il totale importo fattura e se >= allora pagato
        if(importoTotaleLordo !== undefined){
            if(sommatoriaRate >= importoTotaleLordo){ 
                setInsStato("Pagato")
            } else {
                setInsStato("Non pagato")
            }
        }
        setImportoNonPagato(importoTotaleLordo - sommatoriaRate);
    }

    function aggiornaDataScadenzaRata(index,dato){
        let dati = [...arrayDataScadenzaRataFatt];//popolo l'array locale con i dati dell'array di stato
        dati.splice(index,1,dato);//modifico l'elemento desiderato
        setArrayDataScadenzaRataFatt(dati);//aggiorno nuovamente la var di stato
    }

    function aggiornaDataPagamentoRata(index,dato){
        let dati = [...arrayDataPagamentoRataFatt];//popolo l'array locale con i dati dell'array di stato
        dati.splice(index,1,dato);//modifico l'elemento desiderato
        setArrayDataPagamentoRataFatt(dati);//aggiorno nuovamente la var di stato   
    }

    function aggiornaImportoRata(index,dato,aggiornatoAMano=0){
        let dati = [...arrayImportoRataFatt];//popolo l'array locale con i dati dell'array di stato
        dati.splice(index,1,dato);//modifico l'elemento desiderato
        setArrayImportoRataFatt(dati);//aggiorno nuovamente la var di stato
        //if(aggiornatoAMano === 0) setAggiornatoImportoRata(1);
        ricalcolaIvaRate(importoTotaleLordo,ivaTotale,dati);
    }

    function aggiornaNoteRata(index,dato){
        let dati = [...arrayNoteRataFatt];//popolo l'array locale con i dati dell'array di stato
        dati.splice(index,1,dato);//modifico l'elemento desiderato
        setArrayNoteRataFatt(dati);//aggiorno nuovamente la var di stato
    }
    function annullaInserimentoDatiNuovi(){
        setPermessoInserireEnte(0);
        setPermessoInserireRisorsa(0);
        setPermessoInserireVoceDiBilancio(0);
        setPermessoCancellazioneForzata(0);

        tornaScheda();
        //setStatoPagina(STATO_INSERISCI);
    }

    function confermaInserimentoDatiNuovi(){
        setPermessoInserireEnte(1);
        setPermessoInserireRisorsa(1);
        setPermessoInserireVoceDiBilancio(1);
        setPermessoCancellazioneForzata(1);
        //setStatoPagina(STATO_INSERISCI);
    }

    function ricalcolaIvaRate(importoTotFattura,ivaTotFattura,arrayImportoRataFatt){
        let dati = [...arrayIvaRataFatt];//popolo l'array locale con i dati dell'array di stato

        //per ogni rata calcolo il valore dell'iva in proporzione a quanto ammonta l'importo della rata rispetto all'importo totale fattura
        for (let i=0; i<arrayImportoRataFatt.length ; i++) {
            let importoIvaRata = 0;
            if(importoTotFattura!=='' && ivaTotFattura!==''){
                importoIvaRata = FormattaImportoDb(arrayImportoRataFatt[i]) * FormattaImportoDb(ivaTotFattura) / FormattaImportoDb(importoTotFattura);
                if(isNaN(importoIvaRata)) importoIvaRata = 0;
            }            
            dati.splice(i,1,FormattaImportoVideo(importoIvaRata.toFixed(2)));//modifico l'elemento desiderato
        }
        setArrayIvaRataFatt(dati);//aggiorno nuovamente la var di stato
    }


    function aggiungiPagamento() {

        let ese = [...arrayNumeroRate];//popolo l'array locale con i dati dell'array di stato
        ese.push(ese.length);//aggiungo un elemento (per ora vuoto) all'array locale
        setArrayNumeroRate(ese);//aggiorno nuovamente la var di stato

        let riso = [...arrayRisorsaRataFatt];
        riso.push("");
        setArrayRisorsaRataFatt(riso);

        let voci = [...arrayVociDiBilancioRataFatt];
        voci.push(arrayVociDiBilancioRataFatt[0]!==undefined ? arrayVociDiBilancioRataFatt[0] : "");
        setArrayVociDiBilancioRataFatt(voci);

        let dpagamento = [...arrayDataPagamentoRataFatt];//
        dpagamento.push(dataOggi);
        setArrayDataPagamentoRataFatt(dpagamento);

        let dscad = [...arrayDataScadenzaRataFatt];
        dscad.push("");
        setArrayDataScadenzaRataFatt(dscad);

        let importo = [...arrayImportoRataFatt];
        importo.push("");
        setArrayImportoRataFatt(importo);

        let iva = [...arrayIvaRataFatt];
        iva.push("");
        setArrayIvaRataFatt(iva);

        let note = [...arrayNoteRataFatt];
        note.push("");
        setArrayNoteRataFatt(note);
        
        // valori iniziali di un pagamento vuoto
        setArrayRataFatt(prev => [
            ...prev,
            { 
                RISORSA: "",
                IMPORTO_RATA: 0,
                IVA_RATA: 0,
                DATA_SCADENZA_RATA: "",
                DATA_PAGAMENTO_RATA: "",
                NOTE_RATA: "",
                VOCE_DI_BILANCIO: "",
                TIPO_ATTIVITA: "",
                NUMERO_RICEVUTA: "",
                JSON_RICEVUTA: "",
                NUMERO_FATTURA: "",
                DOWNLOAD_XML: 0,
                STATO_XML: 0
            }
        ]);
    }

    function fetchOperazioneServer(bypassaControlli=0,presentaRicevuta=0) {
        setFlagAttivaModaleRichiediPermessoInserire(0);
        //invio l'azione da fare sul server (aggiungi/togli) e l'elemento in esame al server che mi ritornerà l'elenco aggiornato
        let controlli=0;

        //cancello comunque;
        if(props.ope!=='cancella' && bypassaControlli===0){
            if(note.current.value.length>500){
                controlli = 1;
                alert("Il campo Note contiene troppi caratteri (massimo accettato 500)");
                setDisabilitaBottoni(false);
            }

            if (props.tipologia==="incassi_iscritti") {
                if(insIscrittiEdi=== ''){
                    controlli = 1;
                    setFlagAttivaModaleInserisciIscritto(1);
                }
            }

            if (props.tipologia==="incassi_fornitori") {
                if(insClienteFornitoreEdi=== ''){
                    controlli = 1;
                    setFlagAttivaModaleInserisciEnte(1);
                }
            }

            /*
            if(descrizione.current.value=== ''){
                controlli = 1;
                setFlagAttivaModaleInserisciDescrizione(1);
            }
                */
               /*
            if(importo.current.value=== ''){
                controlli = 1;;
                setFlagAttivaModaleInserisciImporto(1);
            }
                */
            if(dataEmissione.current.value=== ''){
                controlli = 1;
                setFlagAttivaModaleInserisciDataEmissione(1);
            }
            /*
            if(isNaN(FormattaImportoDb(importo.current.value))){
                controlli = 1;
                setFlagAttivaModaleImportoErrato(1);
            }
            if(imponibile.current.value==="") imponibile.current.value = 0;
            if(iva.current.value==="") iva.current.value = 0;
            if(isNaN(FormattaImportoDb(imponibile.current.value))){
                controlli = 1;
                setFlagAttivaModaleImponibileErrato(1);
            }
            if(isNaN(FormattaImportoDb(iva.current.value))){
                controlli = 1;
                setFlagAttivaModaleIvaErrata(1);
            }*/
            let sommatoriaRate = 0;
            //controllo che ogni pagamento abbia la data di pagamento indicata:
            for (let i=0; i<arrayNumeroRate.length; i++) { 
                if(arrayDataPagamentoRataFatt[i]==='' || !(arrayDataPagamentoRataFatt[i])){
                    controlli = 1;
                    setFlagAttivaModaleInserisciDataPagamento(1);             
                }else{
                    arrayDataPagamentoRataFatt[i] = controllaDataAAAAMMGG(arrayDataPagamentoRataFatt[i], 2015);
                    if (arrayDataPagamentoRataFatt[i] == "errore") {
                        var nPag = i+1;
                        controlli = 1;
                        alert("La Data di Pagamento del pagamento numero " + nPag + " non è valida");
                        setDisabilitaBottoni(false);
                        annullaInserimentoDatiNuovi();
                    }
                }
                if(arrayRisorsaRataFatt[i]==='' || !(arrayRisorsaRataFatt[i])){
                    controlli = 1;
                    setFlagAttivaModaleInserisciRisorsa(1);             
                }
                if(arrayVociDiBilancioRataFatt[i]==='' || !(arrayVociDiBilancioRataFatt[i])){
                    controlli = 1;
                    setFlagAttivaModaleInserisciVoceBilancio(1);             
                }
                if(arrayImportoRataFatt[i]==='' || !(arrayImportoRataFatt[i])){
                    controlli = 1;
                    setFlagAttivaModaleInserisciImportoPagamento(1);             
                }
                if(isNaN(arrayImportoRataFatt[i])){
                    controlli = 1;
                    setFlagAttivaModaleImportoPagamentoErrato(1);
                }
                /*if(isNaN(FormattaImportoDb(arrayIvaRataFatt[i]))){
                    controlli = 1;
                    setModaleIvaPagamentoErrata(true);
                    setFlagAttivaModaleIvaPagamentoErrata(1);
                }*/
                if(arrayImportoRataFatt[i]!==undefined && arrayImportoRataFatt[i]!==''){
                    sommatoriaRate = sommatoriaRate + parseFloat(FormattaImportoDb(arrayImportoRataFatt[i]));
                }
                if(arrayNoteRataFatt[i].length>500){
                    controlli = 1;
                    alert("Un campo Note Pagamento contiene troppi caratteri (massimo accettato 500)");
                    setDisabilitaBottoni(false);
                }
            }
            if(sommatoriaRate > FormattaImportoDb(importoTotaleLordo)){
                alert("La somma degli importi dei pagamenti non può essere superiore all'importo totale dell'incasso")
                setDisabilitaBottoni(false);
                controlli = 1;
            }
        }

        if(controlli===0){ 
            if(props.ope==='modifica' && variazioneCampi===0){
                //in relatà non e stata fatta alcuna variazione nei campi originali per cui torno ad elenco:
                tornaElenco();
            }else{
                // parametri per inviare i dati al server:
                setLoading(true);

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: props.ope!=='cancella' ?  JSON.stringify({op:operazione,
                        clienteFornitore:insClienteFornitoreEdi,
                        persona:insIscrittiEdi,

                        permessoInserireEnte:permessoInserireEnte,
                        permessoInserireRisorsa:permessoInserireRisorsa,
                        permessoInserireVoceDiBilancio:permessoInserireVoceDiBilancio,
                        importo:importoTotaleLordo,
                        imponibile:imponibileTotale,
                        iva:ivaTotale,
                        tipologia:props.tipologia,
                        dataEmissione:dataEmissione.current.value,
                        stato:insStato,
                        note:note.current.value,
                        dettaglioLinee:serializeDettaglioLinee(dettaglioLinee),

                        arrayRisorsaRataFatt:arrayRisorsaRataFatt,
                        arrayVociDiBilancioRataFatt:arrayVociDiBilancioRataFatt,
                        arrayDataScadenzaRataFatt:arrayDataScadenzaRataFatt ,
                        arrayDataPagamentoRataFatt:arrayDataPagamentoRataFatt,  
                        arrayImportoRataFatt:arrayImportoRataFatt,
                        arrayIvaRataFatt:arrayIvaRataFatt, 
                        arrayNoteRataFatt:arrayNoteRataFatt,   
                        arrayNumeroRate:arrayNumeroRate,  

                        idElemento:props.id,
                        emak: props.emak,
                        sessionId:props.sessionId
                    })
                    : 
                        JSON.stringify({op:operazione,
                        idElemento:props.id,
                        permessoCancellazioneForzata:permessoCancellazioneForzata,
                        emak: props.emak,
                        sessionId:props.sessionId})
                };
            
                // qui faccio la chiamata alla pagina sul server, quindi ne leggo la risposta che io trasformo in oggetto json 
                // con .json() ottenendo "valore_di_ritorno": in questo oggetto json ho "risultato_ritorno" che metto nella 
                // variabile di stato "risultato_server"
                //setStatoPagina(STATO_MEMORIZZAZIONE);

                fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                    .then(risposta => risposta.json())
                    .then(
                    (valoreDiRitorno) => {
                        setLoading(false);
                        if(valoreDiRitorno.risultatoOperazione===1){
                            if(presentaRicevuta === 0){
                                tornaElenco(1);
                            }else{
                                if (valoreDiRitorno.jsonRicevuta) {                                    
                                    setStringaJsonRicevuta(valoreDiRitorno.jsonRicevuta);                                    
                                    setStatoPagina(STATO_VISUALIZZA_RICEVUTA_DOPO_INS);
                                } else {
                                    setStatoPagina(STATO_PREPARA_PDF);
                                }
                            }
                        }
                        if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                        if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                            let flagGestito = false;
                            if(valoreDiRitorno.mess !== undefined){
                                if(valoreDiRitorno.mess.indexOf("Indicare la partita iva per individuazione") !== -1){
                                    setFlagAttivaModaleRichiediPIVA(1);
                                    flagGestito = true;
                                } 
                                if(valoreDiRitorno.mess.indexOf("Richiedi permesso per inserire fornitore") !== -1){
                                    setPermessoInserireEnte(-1);
                                    setFlagAttivaModaleRichiediPermessoInserire(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Richiedi permesso per inserire iscritto") !== -1){
                                    alert("Seleziona un iscritto già presente in anagrafica");
                                    setDisabilitaBottoni(false);
                                    flagGestito = true;
                                } 
                                if(valoreDiRitorno.mess.indexOf("Richiedi permesso per inserire risorse") !== -1){
                                    setPermessoInserireRisorsa(-1);
                                    setRisorseNuove(valoreDiRitorno.risorse_nuove);
                                    setFlagAttivaModaleRichiediPermessoInserire(1);
                                    flagGestito = true;
                                } 
                                if(valoreDiRitorno.mess.indexOf("Richiedi permesso per inserire voci di bilancio") !== -1){
                                    setPermessoInserireVoceDiBilancio(-1);
                                    setVociDiBilancioNuove(valoreDiRitorno.voci_di_bilancio_nuove);
                                    setFlagAttivaModaleRichiediPermessoInserire(1);
                                    flagGestito = true;
                                } 
                                if(valoreDiRitorno.mess.indexOf("Richiedi titolare fattura") !== -1){
                                    if (props.tipologia==="incassi_fornitori") setFlagAttivaModaleInserisciEnte(1);
                                    if (props.tipologia==="incassi_iscritti") setFlagAttivaModaleInserisciIscritto(1);


                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Dato non cancellabile: presente in prima nota") !== -1){
                                    setPermessoCancellazioneForzata(-1);
                                    setFlagAttivaModaleIncassoNonCancellabile(1);
                                    flagGestito = true;
                                } 
                                if(valoreDiRitorno.mess.indexOf("Descrizione non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciDescrizione(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Data pagamento non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciDataPagamento(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Data emissione non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciDataEmissione(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Risorsa non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciRisorsa(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Voce bilancio non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciVoceBilancio(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Importo non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciImporto(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Importo pagamento non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciImportoPagamento(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Importo pagamento errato") !== -1){
                                    setFlagAttivaModaleImportoPagamentoErrato(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Iva pagamento errata") !== -1){
                                    setFlagAttivaModaleIvaPagamentoErrata(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Importo errato") !== -1){
                                    setFlagAttivaModaleImportoErrato(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Imponibile errato") !== -1){
                                    setFlagAttivaModaleImponibileErrato(1);
                                    flagGestito = true;
                                }
                                if(valoreDiRitorno.mess.indexOf("Iva errata") !== -1){
                                    setFlagAttivaModaleIvaErrata(1);
                                    flagGestito = true;
                                }
                            }
                            if (!flagGestito) {
                                if (valoreDiRitorno.mess!==undefined) {
                                    alert(valoreDiRitorno.mess);
                                    setDisabilitaBottoni(false);
                                } else {
                                    //altrimenti vado in errore generico
                                    setStatoPagina(STATO_OPERAZIONE_FALLITA);
                                }
                            }
                        } 
                    },
                    (error) => {setLoading(true);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
                );
            }
        }
    }

    const sx = {
        riga: {
            display: "flex",
            flexWrap: "wrap",          // se lo spazio non basta, solo la select può andare a capo
            alignItems: "flex-end",
            gap: "8px 12px",
            marginBottom: 10,
            padding: "6px 0",
            borderBottom: "1px dashed #ddd",
        },
        campoCol: {
            display: "flex",
            flexDirection: "column",
        },
        colDescr: { flex: "1 1 40%", minWidth: 220 },
        colImporto: { flex: "0 0 170px" },
        colIva: { flex: "0 1 320px" }, // questa può andare a capo
        azioniRiga: { display: "flex", alignItems: "center", gap: 8 },
        azioniGlobali: { marginTop: 8, display: "flex", gap: 8 },
    };

    const patchLinea = (id, patch) => {
        setDettaglioLinee((prev) => prev.map((r) => (r._id === id ? { ...r, ...patch } : r)));
    };

    const aggiungiLinea = () => {
        setDettaglioLinee((prev) => [
            ...prev,
            {
            _id: nextIdRef.current++,
            descrizione: "",
            importoIVAC: "0.00",                // string durante la digitazione: no salti di caret
            aliquotaIVA: aliquotaIVAIniziale ?? 22, // fallback se non è ancora arrivata
            },
        ]);
    };

    const rimuoviLinea = (id) => {
        setDettaglioLinee((prev) => {
            const out = prev.filter((r) => r._id !== id);
            return out.length
            ? out
            : [
                {
                    _id: nextIdRef.current++,
                    descrizione: "",
                    importoIVAC: "0.00",
                    aliquotaIVA: aliquotaIVAIniziale ?? 22,
                },
                ];
        });
    };

    const toVisual = (s) => (s == null ? "" : String(s).replaceAll(".", ",")); // per l'input
    const toInternal = (s) => (s == null ? "" : String(s).replaceAll(",", ".")); // per lo stato
    const normalize2dec = (s) => {
        const n = Number(toInternal(s));
        return isNaN(n) ? "0.00" : n.toFixed(2); // nello stato: sempre col punto
    };

    // normalizza importo a 2 decimali con il punto (string)
    const ensure2decDot = (v) => {
        const n = Number(String(v ?? "0").replace(",", "."));
        return Number.isFinite(n) ? n.toFixed(2) : "0.00";
    };

    // serializza dettaglioLinee in stringa JSON
    const serializeDettaglioLinee = (lines) => {
        const cleaned = (lines || [])
            .filter((r) => r && r._id !== -1) // scarta eventuale riga provvisoria
            // Se vuoi scartare righe vuote, scommenta la riga seguente:
            // .filter((r) => (r.descrizione?.trim()?.length ?? 0) > 0 || Number(String(r.importoIVAC).replace(",", ".")) > 0)
            .map((r) => ({
            descrizione: (r.descrizione ?? "").trim(),
            importoIVAC: ensure2decDot(r.importoIVAC),  // stringa "12.34"
            aliquotaIVA: String(r.aliquotaIVA ?? ""),   // sempre stringa (es. "22" oppure "N4")
            }));

        return JSON.stringify(cleaned);
    };

    if (statoPagina === STATO_VISUALIZZA_RICEVUTA) {
        return (
            <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                    <VisualizzaRicevuta {...props} 
                        jsonRicevuta={JSON.parse(arrayRataFatt[rataSelezionata].JSON_RICEVUTA)}
                        callback={callbackVisualizzaRicevuta}
                    />
                </div>
            </div>
        )
    }

    if (statoPagina === STATO_VISUALIZZA_RICEVUTA_DOPO_INS) {
        return (
            <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                    <VisualizzaRicevuta {...props} 
                        jsonRicevuta={stringaJsonRicevuta}
                        callback={() => tornaElenco(1)}
                    />
                </div>
            </div>
        )
    }

    return (
        <div id="cont" style={{minHeight: "100%",backgroundColor:"#F2F2F2"}}>
            {statoPagina === STATO_SCARICA_PDF ? 
                <div>
                    <div style={{height: props.dimensioniApp.yMain,width: larghezzaPdf,display:"flex"}}><Clessidra loading={true}/></div>
                    {arrayNumeroRate !== undefined && arrayNumeroRate !=='' && arrayNumeroRate.length>0 ?
                    <div style={{position:"absolute",top:props.dimensioniApp.yTitolo}}>
                    {arrayNumeroRate.map((elemento,index) => <div key={index}>
                        {ricevutaNumero === -1 || ricevutaNumero === elemento ? 
                            <PDFViewer style={index === 0 ? 
                                //se metto il primo in posizione assoluta con:
                                //{height: props.dimensioniApp.yMain,width: larghezzaPdf ,display:"flex", flexDirection:"column",backgroundColor:"transparent",position:"absolute",top:props.dimensioniApp.yTitolo}>
                                //poi non vedo più il secondo, ma se non metto la posizione assoluta non posso mettere la Clessidra!
                                {flex:1, height: props.dimensioniApp.yMain,width: larghezzaPdf ,display:"flex", flexDirection:"column",backgroundColor:"transparent"}
                                :{flex:1, height: props.dimensioniApp.yMain,width: larghezzaPdf,display:"flex", flexDirection:"column",backgroundColor:"transparent"} 
                            }>
        
                            <Document>
                            <Page size="A4" style={styles.page}>
                            <View style={{width:"100%"}} >
                                <View style={styles.tableIntestazione} > {/*apre table intestazione*/}
                                    <View wrap={false} style={styles.tableRowIntestazione}> 
                                        <View style={styles.tableColIntestazioneSx}> 
                                            <View style={styles.tableCell}> 
                                                {fileLogo !== "" ? <Image style={styles.logo} src={"data:" + typeLogo + ";base64," + fileLogo} />:<Text></Text>}                                    
                                            </View> 
                                        </View> 
                                        <View style={styles.tableColIntestazioneDx}>   
                                            <View style={styles.tableCellIntestazione}> 
                                                {nomeSocieta !== "" ?<Text style={styles.nomesocieta}>{nomeSocieta}</Text>:<Text></Text>}

                                                {indirizzoSocieta !== "" ?
                                                <Text style={styles.datisocieta}>{indirizzoSocieta}
                                                {cittaSocieta !== "" ?
                                                    capSocieta !== "" ?
                                                        " "+capSocieta+" "+cittaSocieta
                                                    :" "+cittaSocieta
                                                :""}
                                                </Text>
                                                :<Text></Text>}
                                                {pIvaSocieta !== "" ?<Text style={styles.datisocieta}>Partita IVA: {pIvaSocieta}</Text>:<Text></Text>}
                                                {codiceFiscaleSocieta !== "" ?<Text style={styles.datisocieta}>Codice Fiscale: {codiceFiscaleSocieta}</Text>:<Text></Text>}
                                            

                                                <Text style={styles.titolo}>
                                                        Ricevuta Incasso
                                                </Text>
                                            </View> 
                                        </View> 
                                    </View> 
                                </View> 

                
                                        <View style={styles.rigaRicevuta}> 
                                            <Text style={styles.testoGrande}>Si dichiara di ricevere da </Text>
                                        </View>  
                                           
                                        <View style={styles.rigaRicevutaCentrata}> 
                                            {props.tipologia==="incassi_iscritti" &&
                                                <Text style={styles.testoGrassetto}>{insIscrittiEdi}</Text>  
                                            }
                                            {props.tipologia==="incassi_fornitori" &&
                                                <Text style={styles.testoGrassetto}>{enteEsternoPdf}</Text>
                                            }
                                        </View> 
                                        {props.tipologia==="incassi_iscritti" && codiceFiscaleIscritto !=="" && <View style={styles.rigaRicevutaCentrata}><Text style={styles.testoGrassetto}>{codiceFiscaleIscritto}</Text></View>}                                         

                                        <View style={styles.rigaRicevutaCentrata}> 
                                            <Text style={styles.testoGrassetto}>{enteEsternoPdf}</Text>  
                                        </View> 

                                        <View style={styles.rigaRicevuta}> 
                                            <Text style={styles.testoGrande}>in data</Text>  
                                        </View>  

                                        <View style={styles.rigaRicevutaCentrata}> 
                                            <Text style={styles.testoGrassetto}><TrasformaDateAUmano data={arrayDataPagamentoRataFatt[index]}></TrasformaDateAUmano></Text>  
                                        </View>  

                                        <View style={styles.rigaRicevuta}> 
                                            <Text style={styles.testoGrande}>la somma pari a</Text>   
                                        </View> 

                                        <View style={styles.rigaRicevutaCentrata}> 
                                            <Text style={styles.testoGrassetto}>{FormattaImportoVideo(arrayImportoRataFatt[index])} euro</Text>  
                                        </View> 
                                    
                                        <View style={styles.rigaRicevuta}>  
                                            <Text style={styles.testoGrande}>per: {descrizioneDefault} {arrayNoteRataFatt[index]}</Text>  
                                        </View>  
                                        
                                        </View>
                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                </Page>
                </Document>
                </PDFViewer>
                            :""}
                </div>)}
                </div>//div
                :""}

                </div>

            :""}
            {/*eccola {props.sessionId}*/}
        
            {statoPagina === STATO_MEMORIZZAZIONE ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
            <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
            </div>
            </div> :""}

            {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1C_IncDivFor {error.message}</div> :""}
            {statoPagina === STATO_OPERAZIONE_FALLITA ? <div>Errore per operazione errata</div> :""}
            {statoPagina === STATO_RICERCA_DATI ? <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
            <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/>
            </div>
            </div> :""}

            {statoPagina === STATO_RICERCA_DATI_CORRETTA  ?
            <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                
                {flagAttivaModaleInserisciImportoPagamento===1 ?
                    <Modale 
                        titolo="Richiesta importo pagamento"
                        flagErrore={true}
                        contenuto={<div>Non è stato indicato l'importo, che è necessario</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                :""}

                {flagAttivaModaleInserisciDataPagamento===1 ?
                    <Modale 
                        titolo="Richiesta importo pagamento"
                        flagErrore={true}
                        contenuto={<div>Non è stata indicata la data pagamento, che è necessaria</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                :""}

                {flagAttivaModaleInserisciDataEmissione===1 ?
                    <Modale 
                        titolo="Richiesta data emissione"
                        flagErrore={true}
                        contenuto={<div>Non è stata indicata la data emissione, che è necessaria</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                :""}

                {flagAttivaModaleInserisciVoceBilancio===1 ?
                    <Modale 
                        titolo="Richiesta voce bilancio"
                        flagErrore={true}
                        contenuto={<div>Non è stata indicata la voce di bilancio, che è necessaria</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                :""}

                {flagAttivaModaleInserisciRisorsa===1 ?
                    <Modale 
                        titolo="Richiesta risorsa"
                        flagErrore={true}
                        contenuto={<div>Non è stata indicata la risorsa, che è necessaria</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                :""}

                {flagAttivaModaleInserisciDescrizione===1 ?
                    <Modale 
                        titolo="Richiesta descrizione"
                        flagErrore={true}
                        contenuto={<div>Non è stata indicata la descrizione, che è necessaria</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    /> 
                :""}

                {flagAttivaModaleInserisciImporto===1 ?
                    <Modale 
                        titolo="Richiesta importo"
                        flagErrore={true}
                        contenuto={<div>Non è stato indicato l'importo, che è necessario</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    /> 
                :""} 

                {flagAttivaModaleIncassoNonCancellabile===1 ?
                    <Modale 
                        titolo="Informativa cancellazione incasso"
                        flagErrore={true}
                        contenuto={<div>L'incasso selezionato è associato ad uno o più record in prima nota. Premendo Ok si andrà a cancellare sia il record relativo all'incasso in esame sia i relativi record in prima nota</div>}
                        bottoni={[
                            {
                                "etichetta":"Ok",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);setPermessoCancellazioneForzata(1);fetchOperazioneServer(1)}
                            } ,
                            {
                                "etichetta":"Annulla",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    /> 
                :""}




                {flagAttivaModaleRichiediPermessoInserire===1 ?
                    <Modale 
                    titolo="Richiesta permesso inserire"
                    flagErrore={true}
                    larghezza="lg"
                    contenuto={<div>
                        {permessoInserireEnte===-1 ? <center>Vuoi davvero inserire {insClienteFornitoreEdi} nell'elenco degli enti esterni?<br/></center> :""}
                        {permessoInserireRisorsa===-1 ? <>Vuoi davvero inserire le seguenti nell'elenco delle risorse? 
                                {risorseNuove !== undefined ?
                                    risorseNuove.map(risorseNuoveElemento =>
                                        <div key={risorseNuoveElemento}>
                                        <Label>{risorseNuoveElemento}</Label>
                                        </div>                                                   
                                    )
                                :""}<br/></> :""}
                        {permessoInserireVoceDiBilancio===-1 ?<>Vuoi davvero inserire le seguenti nell'elenco delle voci di bilancio?
                                    {vociDiBilancioNuove !== undefined ?
                                    vociDiBilancioNuove.map(vociDiBilancioNuoveElemento =>
                                        <div key={vociDiBilancioNuoveElemento}>
                                        <Label>{vociDiBilancioNuoveElemento}</Label>
                                        </div>                                                   
                                    )
                                :""}<br/>
                                Inizialmente le nuove voci di bilancio verrnno impostate come attività principale.<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagAttivaModaleSpiegaAttivita(1)}/><br/> E' possibile modificare l'impostazione recandosi in Gestione Economica, Voci di Bilancio, selezionare la voce desiderata e attuare le modifiche.<br/>
                                </> :""}
                        </div>}
                    bottoni={[
                        {
                            "etichetta":"Ok",
                            "tipo":"primary",
                            callback:() => {setDisabilitaBottoni(false);confermaInserimentoDatiNuovi()}
                        } ,
                        {
                            "etichetta":"Annulla",
                            "tipo":"primary",
                            callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                        }    
                    ]}
                /> 
                :""}
                {flagAttivaModaleSpiegaAttivita=== 1 ?
                    <Modale 
                    titolo="Informativa Attività Principali / Secondarie"
                    flagErrore={false}
                    larghezza="lg"
                    contenuto={<div><p>La classificazione di una voce di bilancio come attività principale dipende dalla sua natura.</p> 
                        <p>Per attività principale si intende tutto ciò che è connesso direttamente alle attività sportive ed alle responsabilità istituzionali.
                        L'attivita principale coinvolge i ruoli fondamentali per la pratica sportiva stessa, come istruttori, allenatori, arbitri, tecnici e atleti.
                        Inoltre riguarda tutto ciò che è indispensabile allo svolgimento delle attività sportive: attrezzature, materiali sportivi e strutture adeguate ecc..</p>
                        <p>Sono invece da includere nelle attività secondarie tutto ciò che non è da considerarsi indispensabile per la pratica sportiva diretta.
                        Si tratta spesso di attività legate all’organizzazione e al funzionamento delle strutture sportive.
                        Ad esempio: addetti alla manutenzione degli impianti, addetti alla reception, gestione dell'area ristoro o del merchandising sportivo ecc.. </p>
                        <p>La distinzione tra le attività è utile per adempiere alle norme relative alla Riforma dello Sport.</p>
                        Il <b>report "Attività Principali / Secondarie"</b>, disponibile nella sezione Report, può essere un utile strumento per confrontare il volume di attività 
                        principali e secondarie. 
                        <p>Fornisce inoltre un'analisi dettagliata del rapporto tra attività secondarie e ricavi totali, nonché tra attività secondarie e costi totali.</p>
                    </div>}
                    bottoni={[
                        {
                            "etichetta":"OK",
                            "tipo":"primary",
                            callback:() => {setDisabilitaBottoni(false);setFlagAttivaModaleSpiegaAttivita(0)}
                        }    
                    ]}
                    />
                :""}

                {flagAttivaModaleRichiediPIVA===1 ?
                    <Modale 
                        titolo="Richiesta partita IVA"
                        flagErrore={true}
                        contenuto={<div>Nel database ci sono più enti con Ragione Sociale: {insClienteFornitoreEdi} Si prega di indicare la partita iva in modo da poter individuare quello desiderato oppure per procedere con l'inserimento di un nuovo ente qualorala partita iva non corrispondesse a nessuno degli enti individuati</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);annullaInserimentoDatiNuovi()}
                            }    
                        ]}
                    />
                :""}
                
                {flagAttivaModaleInserisciEnte===1 ?
                    <Modale 
                        titolo="Richiesta ente"
                        flagErrore={true}
                        contenuto={<div>Non è stato indicato l'ente, che è necessario</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);annullaInserimentoDatiNuovi()}
                            }    
                        ]}
                    />  
                :""}

                {flagAttivaModaleInserisciIscritto===1 ?
                    <Modale 
                        titolo="Richiesta iscritto"
                        flagErrore={true}
                        contenuto={<div>Non è stato indicato l'iscritto, che è necessario</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);annullaInserimentoDatiNuovi()}
                            }    
                        ]}
                    /> 
                :""}

                {flagAttivaModaleImponibileErrato===1 ?
                    <Modale 
                        titolo="Informativa imponibile errato"
                        flagErrore={true}
                        contenuto={<div>L'importo inserito per l'imponibile non è un numero: completare il campo con un valore numerico</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);annullaInserimentoDatiNuovi()}
                            }    
                        ]}
                    />  
                :""}

                {flagAttivaModaleImportoErrato===1 ?
                    <Modale 
                        titolo="Informativa importo errato"
                        flagErrore={true}
                        contenuto={<div>L'importo inserito non è un numero: completare il campo con un valore numerico</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);annullaInserimentoDatiNuovi()}
                            }    
                        ]}
                    />  
                :""}

                {flagAttivaModaleIvaErrata===1 ?
                    <Modale 
                        titolo="Informativa importo errato"
                        flagErrore={true}
                        contenuto={<div>L'importo inserito per l'iva non è un numero: completare il campo con un valore numerico</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);annullaInserimentoDatiNuovi()}
                            }    
                        ]}
                    />  
                :""}

                {flagAttivaModaleImportoPagamentoErrato===1 ?
                    <Modale 
                        titolo="Informativa importo pagamento errato"
                        flagErrore={true}
                        contenuto={<div>L'importo inserito nel pagamento non è un numero: completare il campo con un valore numerico</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);annullaInserimentoDatiNuovi()}
                            }    
                        ]}
                    />  
                :""}

                {flagAttivaModaleIvaPagamentoErrata===1 ?
                    <Modale 
                        titolo="Informativa iva Pagamento errata"
                        flagErrore={true}
                        contenuto={<div>L'importo inserito per l'iva pagamento non è un numero: completare il campo con un valore numerico</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);annullaInserimentoDatiNuovi()}
                            }    
                        ]}
                    />  
                :""}

                {flagModaleInfoStato=== true ?
                <Modale 
                    titolo="Informativa Stato Pagamento"
                    flagErrore={false}
                    contenuto="Lo stato pagamento è valorizzato inizialmente a 'Non Pagato' finchè la somma degli importi dei pagamenti non uguaglia o supera il valore dell'importo dell'incasso. Il valore passa a 'Pagato', ma rimane comunque modificabile. Lo stato viene impostato 'Non Pagato' se non è presente alcun pagamento"
                    bottoni={[
                        {
                            "etichetta":"OK",
                            "tipo":"primary",
                            callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                        }    
                    ]}
                />
                :""}

                {flagModaleInfoImporto=== true ?
                <Modale 
                    titolo="Informativa Importo"
                    flagErrore={false}
                    contenuto="L'importo deve comprendere tutto il totale dell'incasso comprensivo di eventuali sconti o maggiorazioni"
                    bottoni={[
                        {
                            "etichetta":"OK",
                            "tipo":"primary",
                            callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                        }    
                    ]}
                />
                :""}

                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                        {props.ope === "inserisci" ? <CardTitle>Inserimento Incasso {props.tipologia=="incassi_iscritti"?" da Iscritto":"da Esterno"}</CardTitle> :""}
                        {props.ope === "modifica" ? 
                            operazioneInterna === 'copia' ?
                            <CardTitle>Inserimento Incasso {props.tipologia=="incassi_iscritti"?" da Iscritto":"da Esterno"}</CardTitle> 
                            :
                            <CardTitle>Modifica Incasso {props.tipologia=="incassi_iscritti"?" da Iscritto":"da Esterno"}</CardTitle> 
                        :""}
                

{/*{noteRata!== undefined ? <CardTitle>mostro noterata in zero={noteRata.current[0].value}</CardTitle> :""}*/}
                        
                        <Clessidra loading={loading}/>

                        {props.ope === "cancella" ?
                            <FinestraDialogo 
                                titolo="Conferma eliminazione"
                                flagErrore={true}                                
                                contenuto={<div>
                                    Confermi l'eliminazione dell'incasso <b>{props.tipologia=="incassi_iscritti"?"dall'iscritto "+insIscrittiEdi:"da Esterno "+insClienteFornitoreEdi}</b>, con importo <b>{FormattaImportoVideo(importoTotaleLordo)}</b> euro e con data emissione <b><TrasformaDateAUmano data={dataEmissioneDefault}></TrasformaDateAUmano></b> ?<br/>                                
                                </div>}
                                bottoni={[
                                    {
                                        "etichetta":"Conferma",
                                        "tipo":"primary",
                                        callback:() => {setDisabilitaBottoni(true);fetchOperazioneServer()}
                                    },
                                    {
                                        "etichetta":"Annulla",
                                        "tipo":"primary",
                                        callback: () => {tornaElenco()}
                                    }
                                ]}
                            />                        

                        :
                            <>
                            
                            {props.tipologia=="incassi_iscritti" && <div style={{marginBottom: 10}}>
                                Utilizza questa funzione per gestire gli incassi dagli iscritti <span style={{color:"#FF0000", fontWeight:'bold'}}>diversi dalle quote associative o di abbonamento</span>
                            </div>}

                            <Row form>  
                                <Col md={6}>
                                    {props.tipologia=="incassi_iscritti" ? 
                                        <>
                                            {props.ope === "inserisci" &&
                                                <>                                                
                                                <Label>Seleziona Iscritto*</Label>
                                                <TendinaEditabile
                                                    //titolo={"Iscritto*"}
                                                    nomeCampo="COGNOME"
                                                    nomeCampo2="NOME"
                                                    nomeCampoParentesi="NUMERO_TESSERA"
                                                    valoreDefault={insIscrittiEdi}
                                                    arrayValori={risultatoServerDatiIscritti}
                                                    callbackSetVariazioneCampi={setVariazioneCampi}
                                                    callbackSetValoreTendEditabile={setInsIscrittiEdi}
                                                ></TendinaEditabile>
                                                </>
                                            }
                                            {props.ope === "modifica" && <Label>Iscritto: {insIscrittiEdi}</Label>}
                                        </>
                                    :
                                        <>
                                            <Label>Ente Esterno*</Label>
                                            <TendinaEditabile
                                                //titolo={"Ente Esterno*"}
                                                nomeCampo="COGNOME"
                                                nomeCampoParentesi="P_IVA"
                                                nomeCampoNonVisibile = "CODICE_FISCALE"
                                                valoreDefault={insClienteFornitoreEdi}
                                                arrayValori={risultatoServerDatiClienteFornitore}
                                                callbackSetVariazioneCampi={setVariazioneCampi}
                                                callbackSetValoreTendEditabile={callbackSetValoreTendEditabileCliFor}
                                            ></TendinaEditabile>
                                        </>
                                    }
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="dataEmissione">Data Emissione*</Label>
                                            <Input maxLength={10} type="date" name="dataEmissione" id="dataEmissione"
                                            innerRef={dataEmissione} 
                                            placeholder=""
                                            defaultValue={dataEmissioneDefault}
                                            onInput={(e)=>{handleCambiamentoMod(e);setDataEmissioneDefault(dataEmissione.current.value);}}/> 
                                    </FormGroup>
                                </Col>
                                <Col md={3}>                            
                                    <FormGroup>                                        
                                        <Label>Stato<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagModaleInfoStato(true)}/></Label><br/>
                                        <select value={insStato} className="inputStandard" onChange={(e) => {handleCambiamentoMod(e);setInsStato(e.target.value)}}>
                                        {insStato === 'Pagato' ? <option selected value="Pagato">Pagato</option> : <option value="Pagato">Pagato</option> }
                                        {insStato === 'Non pagato' ? <option selected value="Non pagato">Non pagato</option> : <option value="Non pagato">Non pagato</option> }
                                        </select>
                                        {importoNonPagato > 0 && <div style={{backgroundColor:"#FF0000", color:"#FFFFFF", padding:3, marginTop:5}}>{"Non ancora pagato: " + FormattaImportoVideo(importoNonPagato)}</div>}
                                        {importoNonPagato < 0 && <div style={{backgroundColor:"#fffc4eff", color:"#000000", padding:3, marginTop:5}}>{"Pagato in eccesso: " + FormattaImportoVideo(-importoNonPagato)}</div>}
                                        {importoNonPagato == 0 && <div style={{padding:3, marginTop:5}}>&nbsp;</div>}
                                    </FormGroup>
                                </Col>
                            </Row>

{/*
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="importo">Imponibile</Label>
                                            <Input maxLength={12} type="text" name="imponibile" id="imponibile"
                                            innerRef={imponibile} 
                                            placeholder=""
                                            defaultValue={FormattaImportoVideo(imponibileTotale,1)}
                                            onInput={(e)=>{handleCambiamentoMod(e);setImponibileTotale(imponibile.current.value)}}/>  
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="iva">IVA</Label>
                                            <Input maxLength={12} type="text" name="iva" id="iva"
                                            innerRef={iva} 
                                            placeholder=""
                                            defaultValue={FormattaImportoVideo(ivaTotale,1)}
                                            onInput={(e)=>{handleCambiamentoMod(e);setIvaTotale(iva.current.value);ricalcolaIvaRate(importoTotaleLordo,iva.current.value,arrayImportoRataFatt);}}/>  
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="importo">Importo*<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagModaleInfoImporto(true)}/></Label>
                                            <Input maxLength={12} type="text" name="importo" id="importo"
                                            innerRef={importo} 
                                            placeholder=""
                                            defaultValue={FormattaImportoVideo(importoTotaleLordo,1)}
                                            onInput={(e)=>{handleCambiamentoMod(e);calcolaPrimoPagamento(importo.current.value);setImportoTotaleLordo(importo.current.value);}}/>  
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="descrizione">Descrizione*</Label>
                                            <Input maxLength={200} type="text" name="descrizione" id="descrizione"
                                            innerRef={descrizione} 
                                            placeholder=""
                                            defaultValue={descrizioneDefault}
                                            onInput={(e)=>{handleCambiamentoMod(e);setDescrizioneDefault(descrizione.current.value);}}/> 
                                    </FormGroup>
                                </Col>
*/}
                                                            
                            <div className='schedaSottotitolo'>
                                {props.tipologia=="incassi_fornitori" ? "Articoli" : "Causali"}
                            </div>

                            <Row>
                                <Col md={12}>
                                    <div>
                                        {(dettaglioLinee?.length ? dettaglioLinee : [
                                            // se ancora vuoto e non è arrivata l'aliquota, mostra una riga provvisoria
                                            { _id: -1, descrizione: "", importoIVAC: "0.00", aliquotaIVA: aliquotaIVAIniziale ?? 22 }
                                        ]).map((linea) => (
                                            <div key={linea._id} style={sx.riga}>
                                            {/* Descrizione */}
                                            <div style={{ ...sx.campoCol, ...sx.colDescr }}>
                                                <label>Descrizione*</label>
                                                <input
                                                type="text"
                                                className="inputStandard"
                                                value={linea.descrizione}
                                                onChange={(e) => {
                                                    if (linea._id === -1) return; // riga provvisoria (non mutare lo stato)
                                                    handleCambiamentoMod(e);
                                                    patchLinea(linea._id, { descrizione: e.target.value });
                                                }}
                                                />
                                            </div>

                                            {/* Importo IVA compresa */}
                                            <div style={{ ...sx.campoCol, ...sx.colImporto }}>
                                                <label>Importo (IVA compresa)*</label>
                                                <input
                                                    type="text"
                                                    inputMode="decimal"
                                                    className="inputStandard"
                                                    value={toVisual(linea.importoIVAC)}          // mostra la virgola
                                                    onChange={(e) => {
                                                        handleCambiamentoMod(e);
                                                        if (linea._id === -1) return;
                                                        // salva con il punto, senza normalizzare durante la digitazione
                                                        const raw = e.target.value;                // con virgola
                                                        patchLinea(linea._id, { importoIVAC: toInternal(raw) });
                                                    }}
                                                    onBlur={(e) => {
                                                        if (linea._id === -1) return;
                                                        // al blur normalizza a 2 decimali (interno col punto)
                                                        const normalized = normalize2dec(e.target.value);
                                                        patchLinea(linea._id, { importoIVAC: normalized });
                                                    }}
                                                    />
                                            </div>

                                            {/* Aliquota IVA (può andare a capo da sola) */}
                                            <div style={{ ...sx.campoCol, ...sx.colIva }}>
                                                <label>Aliquota IVA*</label>
                                                <AliquotaIVASelect
                                                value={linea.aliquotaIVA}
                                                onValueChange={(v) => {
                                                    handleCambiamentoMod(v);
                                                    if (linea._id === -1) return;
                                                    patchLinea(linea._id, { aliquotaIVA: v });
                                                }}
                                                // se usi classi tue, aggiungi className; qui solo inline:
                                                className="inputStandard"
                                                />
                                            </div>

                                            {/* Azioni riga */}
                                            <div style={sx.azioniRiga}>
                                                <Button color="primary"
                                                    onClick={(e) => {
                                                        if (linea._id === -1) return;
                                                        handleCambiamentoMod(e);
                                                        rimuoviLinea(linea._id);
                                                    }}
                                                    tabIndex={0}
                                                >
                                                Rimuovi
                                                </Button>
                                            </div>
                                            </div>
                                        ))}

                                        {/* Azioni globali */}
                                        <div style={sx.azioniGlobali}>
                                            <Button color="primary" onClick={aggiungiLinea} tabIndex={0}>
                                            Aggiungi riga
                                            </Button>
                                        </div>
                                        </div>
                                    


                                </Col>
                            </Row>

                            <div className='schedaSottotitolo'>
                                Totali
                            </div>

                            <div style={{display:'flex', flexDirection:'row', fontSize:18}}>
                                <div style={{flex:1}}>Imponibile: {FormattaImportoVideo(imponibileTotale)} €</div>
                                <div style={{flex:1}}>IVA: {FormattaImportoVideo(ivaTotale)} €</div>
                                <div style={{flex:1}}>
                                    Importo Totale: {FormattaImportoVideo(importoTotaleLordo)} €
                                    {Math.abs(importoTotaleLordo-ivaTotale-imponibileTotale)>0.001 &&
                                        <div style={{fontSize:12}}>
                                            Arrotondamento: {FormattaImportoVideo(importoTotaleLordo-ivaTotale-imponibileTotale)} €
                                        </div>
                                    }

                                </div>
                            </div>

                            <div className='schedaSottotitolo'>
                                Pagamenti
                            </div>

                            <Row>
                            <Col lg="12">
                                <FormGroup>
                                {arrayNumeroRate !== undefined && arrayNumeroRate !=='' && arrayNumeroRate.length>0 &&
                                    arrayNumeroRate.map((elemento,index) => 
                                        <div key={index}>
                                            <FormGroup>
                                                <Row>  
                                                    <Col lg="1">
                                                        {(variazioneCampi === 0 && props.ope === "modifica") ?
                                                            <Button 
                                                                disabled={disabilitaBottoni}
                                                                color="success"
                                                                className="mt-2 bottoneMargineADestra"
                                                                onClick={() => {
                                                                    if (arrayRataFatt[index].JSON_RICEVUTA=="") {
                                                                        // ricevute di tipo vecchio, senza numero di ricevuta e con la sola descrizione, visualizzate da questa pagina
                                                                        setRicevutaNumero(elemento);
                                                                        setStatoPagina(STATO_PREPARA_PDF);
                                                                        setDisabilitaBottoni(true);
                                                                    } else {
                                                                        // ricevute di tipo nuovo, con numero di ricevuta e tabella causali, visualizzate da VisualizzaRicevuta.js
                                                                        setRataSelezionata(index);
                                                                        setStatoPagina(STATO_VISUALIZZA_RICEVUTA);
                                                                    }
                                                                }}
                                                            >
                                                                Stampa ricevuta
                                                            </Button>
                                                        :""}
                                                    </Col>
                                        
                                                    <Col lg="5">
                                                    <FormGroup>
                                                    <Label for="risorsa">Risorsa*</Label>
                                                            <TendinaEditabile
                                                                nomeCampo="DESCRIZIONE"
                                                                //valoreDefault={defaultRisorse[index]}
                                                                valoreDefault={arrayRisorsaRataFatt[index]}
                                                                arrayValori={risultatoServerDatiTutteRisorse}
                                                                posizioneTendina = {index}
                                                                callbackSetVariazioneCampi={setVariazioneCampi}
                                                                callbackSetValoreTendEditabile={callbackSetValoreTendEditabileRisorsa}
                                                                eliminazioneRata={arrayRisorsaRataFatt[index]}
                                                            ></TendinaEditabile>
                                                    </FormGroup>
                                                    </Col>

                                                    <Col lg="6">
                                                    <FormGroup>
                                                    
                                                    <label htmlFor="voce">
                                                    Voce di Bilancio*
                                                    {arrayVociDiBilancioAttRataFatt[index] === '1' 
                                                        ? <> (attività principale<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagAttivaModaleSpiegaAttivita(1)}/>)</> 
                                                        : arrayVociDiBilancioAttRataFatt[index] === '0' 
                                                        ? <> (attività secondaria<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagAttivaModaleSpiegaAttivita(1)}/>)</>
                                                        : ''
                                                    }
                                                    </label>    
                                                        <TendinaEditabile
                                                            nomeCampo="DESCRIZIONE"
                                                            nomeCampoNonVisibile = "TIPO_ATTIVITA"
                                                            //valoreDefault={defaultVociDiBilancio[index]}
                                                            valoreDefault={arrayVociDiBilancioRataFatt[index]}
                                                            arrayValori={risultatoServerDatiTutteVociDiBilancio}
                                                            posizioneTendina = {index}
                                                            callbackSetVariazioneCampi={setVariazioneCampi}
                                                            callbackSetValoreTendEditabile={callbackSetValoreTendEditabileVociDiBilancio}
                                                        ></TendinaEditabile>
                                                    </FormGroup>
                                                    </Col>
                                                </Row>
                                            
                                                <Row>
                                                    <Col lg="1"><center><img onClick={() => { handleCambiamentoMod(1);eliminaRataFattura(index);}} src={Cestino}/></center></Col>
                                                    <Col lg="4">
                                                        <FormGroup>
                                                        <Label for="dataScadenzaRata">Data Scad. Pagamento</Label>
                                                        <Input maxLength={10} type="date"  value={arrayDataScadenzaRataFatt[index]} 
                                                        ref={(elemento1) => dataScadenzaRata.current[index] = elemento1}
                                                                placeholder="" onInput={(e)=>{handleCambiamentoMod(e);aggiornaDataScadenzaRata(index,e.target.value)}}/> 
                                                        </FormGroup>
                                                    </Col>
                                                                                    
                                                    <Col lg="4">
                                                        <FormGroup>
                                                        <Label for="dataPagamentoRata">Data Pagamento*</Label>
                                                        <Input maxLength={10} type="date"  value={arrayDataPagamentoRataFatt[index]} 
                                                        ref={(elemento1) => dataPagamentoRata.current[index] = elemento1}
                                                                placeholder="" onInput={(e)=>{handleCambiamentoMod(e);aggiornaDataPagamentoRata(index,e.target.value);}}/> 
                                                        </FormGroup>
                                                    </Col>
                                                    
                                                    <Col lg="3">
                                                    
                                                    <FormGroup>
                                                        <Label for="importoPagamento">Importo Pagamento* {arrayImportoRataFatt[index]}</Label>
                                                            <Input maxLength={12} type="text"
                                                            innerRef={(elemento1) => importoRata.current[index] = elemento1}
                                                            placeholder=""
                                                            value={toVisual(arrayImportoRataFatt[index])}
                                                            onInput={(e)=>{handleCambiamentoMod(e);aggiornaImportoRata(index,toInternal(e.target.value))}}/>
                                                    </FormGroup>

                                                    </Col>
                                                </Row> 

                                                <Row> 
                                                    <Col lg="1">
                                                        <Label for=""></Label>
                                                    </Col>
                                                    <Col lg="11">
                                                        <FormGroup>
                                                            <Label for="noteRata">Note Pagamento</Label>
                                                            <Input type="text"  value={arrayNoteRataFatt[index]} 
                                                            ref={(elemento1) => noteRata.current[index] = elemento1}
                                                                    placeholder="" onInput={(e)=>{handleCambiamentoMod(e);aggiornaNoteRata(index,e.target.value)}}/> 
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                                <Row> 
                                                    <Col lg="1">
                                                        <Label for=""></Label>
                                                    </Col>
                                                    <Col lg="11">
                                                        Fattura elettronica:&nbsp;
                                                        {arrayRataFatt[index].STATO_XML == 0 ? 
                                                            "non generata" 
                                                        : 
                                                            arrayRataFatt[index].NUMERO_FATTURA+", "+((arrayRataFatt[index].DOWNLOAD_XML == 0) ? "non scaricata" : "scaricata")
                                                        }
                                                    </Col>
                                                </Row>
                                        
                                            </FormGroup>
                                        </div>)      
                                    }

                                </FormGroup>
                            </Col>
                            </Row>

                            <Row form>  
                                <Col md={12}>
                                    <FormGroup>
                                        <Row form> 
                                        <Col md={12}><Button color="primary" className="mt-2" onClick={() => {
                                            handleCambiamentoMod(1);
                                            aggiungiPagamento();}} 
                                        >Aggiungi Pagamento</Button></Col>
                                        </Row>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row form>  
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="note">Note</Label>
                                            <Input type="text" name="note" id="note"
                                            innerRef={note} 
                                            placeholder=""
                                            defaultValue={noteDefault}
                                            onInput={(e)=>{handleCambiamentoMod(e);setNoteDefault(note.current.value);}}/> 
                                    </FormGroup>
                                </Col>
                            </Row>
                            </>
                            }
                        
                                
                            </div>

                            <div className="schedaSpazioInferiore">
                            {props.ope === "inserisci" || operazioneInterna === 'copia' ? <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Inserisci senza ricevuta</Button> :""}
                            {props.ope === "inserisci" || operazioneInterna === 'copia' ? <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer(0,1);setRicevuta(1)}}>Inserisci con ricevuta</Button> :""}
                            {props.ope === "modifica" && variazioneCampi === 1 && operazioneInterna === ''? <Button disabled={disabilitaBottoni} color="warning" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Memorizza Modifiche</Button>:""}
                            
                            {props.ope === "modifica" && variazioneCampi === 0 && operazioneInterna === ''? 
                                <Button disabled={disabilitaBottoni} color="warning" className="mt-2 bottoneMargineADestra" onClick={() => {copiaMovimento()}}>Copia Incasso</Button>
                            :""}

                            <Button disabled={disabilitaBottoni} color="primary" className="mt-2 bottoneMargineADestra" onClick={() => tornaElenco()} >
                            {(variazioneCampi === 1 && props.ope === "modifica") ?  <Fragment>Annulla</Fragment>: <Fragment>Torna all'elenco</Fragment>}
                            </Button>

                            {/*
                            {(variazioneCampi === 0 && props.ope === "modifica") ?
                                <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);setStatoPagina(STATO_PREPARA_PDF)}}>Stampa ricevute</Button>
                            :""}
                            */}
                            
                            </div>

            </div>
            :""}
        </div>
    );
}
export default SchedaIncassiDiversi;
